module.exports = __webpack_public_path__ + "media/download_free_materials/40x48DownloadIconLeftAccentWhiteFromAI-3998266d.png";